import React from 'react';
import { useLanguage } from '@/context/LanguageContext';
import { Briefcase, TrendingUp, Users } from 'lucide-react';

const CareersSection = () => {
  const { t } = useLanguage();

  return (
    <section id="careers" className="bg-slate-50 section-spacing" data-testid="careers-section">
      <div className="container-custom">
        <h2 
          className="text-3xl md:text-5xl font-bold text-[#0047AB] text-center mb-4"
          data-testid="careers-title"
        >
          {t('careersTitle')}
        </h2>
        <div className="section-divider mb-12"></div>

        <div className="max-w-3xl mx-auto text-center">
          <p className="text-base md:text-lg text-slate-600 leading-relaxed mb-12" data-testid="careers-desc">
            {t('careersDesc')}
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-white p-6 shadow-sm">
              <div className="w-14 h-14 bg-[#0047AB]/10 flex items-center justify-center mx-auto mb-4">
                <Briefcase className="w-7 h-7 text-[#0047AB]" />
              </div>
              <h4 className="font-bold text-slate-800 mb-2">Manufacturing</h4>
              <p className="text-sm text-slate-600">Production & Quality Control roles</p>
            </div>
            <div className="bg-white p-6 shadow-sm">
              <div className="w-14 h-14 bg-[#0047AB]/10 flex items-center justify-center mx-auto mb-4">
                <TrendingUp className="w-7 h-7 text-[#0047AB]" />
              </div>
              <h4 className="font-bold text-slate-800 mb-2">Sales</h4>
              <p className="text-sm text-slate-600">Territory & Regional Sales positions</p>
            </div>
            <div className="bg-white p-6 shadow-sm">
              <div className="w-14 h-14 bg-[#0047AB]/10 flex items-center justify-center mx-auto mb-4">
                <Users className="w-7 h-7 text-[#0047AB]" />
              </div>
              <h4 className="font-bold text-slate-800 mb-2">Distribution</h4>
              <p className="text-sm text-slate-600">Channel & Partner Management</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CareersSection;
